import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import tweaqLogoTagline from "@/assets/tweaq-logo-tagline.svg";
import { useLangPath } from "@/hooks/use-lang-path";

const Footer = () => {
  const { t } = useTranslation();
  const lp = useLangPath();

  const columns = [
    {
      title: t("nav.solutions"),
      links: [
        { label: "SIM", href: lp("/solutions/sim") },
        { label: "OPS", href: "#" },
      ],
    },
    {
      title: t("footer.industries"),
      links: [
        { label: t("footer.logistics"), href: lp("/industries/logistics") },
        { label: t("footer.buildings"), href: lp("/industries/buildings") },
        { label: t("footer.manufacturing"), href: lp("/industries/manufacturing") },
      ],
    },
    {
      title: t("footer.company"),
      links: [
        { label: t("footer.about"), href: lp("/about") },
        { label: t("footer.careers"), href: lp("/careers") },
        { label: t("footer.contact"), href: lp("/contact") },
      ],
    },
    {
      title: t("footer.policies"),
      links: [
        { label: t("footer.privacy"), href: lp("/privacy") },
        { label: t("footer.terms"), href: lp("/terms") },
      ],
    },
  ];

  return (
    <footer className="bg-surface-carbon">
      <div className="container-narrow px-6">
        <div className="pt-[64px] pb-9 flex flex-col md:flex-row md:justify-between gap-10 md:gap-8">
          <div className="shrink-0">
            <Link to={lp("/")}>
              <img
                src={tweaqLogoTagline}
                alt="tweaq — together we achieve equilibrium"
                className="w-[250px]"
                style={{ filter: "brightness(0) invert(1)" }}
              />
            </Link>
          </div>
          <div className="flex flex-col md:flex-row gap-10 md:gap-[88px]">
            {columns.map((col) => (
              <div key={col.title} className="flex flex-col gap-3">
                <h4 className="text-xs font-semibold uppercase tracking-[0.15em] text-surface-carbon-foreground/60 mb-1">
                  {col.title}
                </h4>
                {col.links.map((link) => (
                  <Link
                    key={link.href}
                    to={link.href}
                    className="text-sm text-surface-carbon-foreground/60 hover:text-surface-carbon-foreground transition-colors"
                  >
                    {link.label}
                  </Link>
                ))}
              </div>
            ))}
          </div>
        </div>
        <div className="border-t border-surface-carbon-foreground/20" />
        <div className="py-5">
          <p className="text-surface-carbon-foreground/60 text-sm">
            {t("footer.copyright")}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
